import { fileUrl } from "@/lib/api";

export default function Infobox({ infobox, accent = "ghoulax", className = "" }) {
  if (!infobox || (!infobox.fields?.length && !infobox.image && !infobox.title)) return null;
  const accentColor = accent === "ghoulax" ? "var(--ghoulax)" : "var(--zyfley)";
  return (
    <aside
      data-testid="article-infobox"
      className={`w-full rounded-md border shadow-sm ${className}`}
      style={{ backgroundColor: "var(--arc-card)" }}
    >
      <div
        className="rounded-t-md border-b px-4 py-3 text-center font-serif-arc text-base font-bold"
        style={{ color: accentColor, borderBottomColor: accentColor }}
      >
        {infobox.title || "Details"}
      </div>
      {infobox.image && (
        <div className="border-b p-3">
          <img src={fileUrl(infobox.image)} alt={infobox.title} className="mx-auto max-h-64 w-full rounded object-cover" />
        </div>
      )}
      <dl className="divide-y">
        {(infobox.fields || []).map((f, i) => (
          <div key={`${f.label}-${i}`} className="grid grid-cols-3 gap-2 px-4 py-2.5 text-sm">
            <dt className="col-span-1 font-semibold" style={{ color: "var(--arc-text-2)" }}>{f.label}</dt>
            <dd className="col-span-2">{f.value}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
}
